import { Routes, Route } from 'react-router-dom';
import AppShell from '@/components/layout/AppShell';
import AuthGate from '@/components/auth/AuthGate';
import DashboardPage from '@/pages/DashboardPage';
import UploadPage from '@/pages/UploadPage';
import AnalyzePage from '@/pages/AnalyzePage';

function App() {
  return (
    <AuthGate>
      <AppShell>
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/upload" element={<UploadPage />} />
          <Route path="/analyze/:jobId" element={<AnalyzePage />} />
        </Routes>
      </AppShell>
    </AuthGate>
  );
}

export default App;
